__turbopack_context__.v({
  "default": "input-module-scss-module__XgxsSW__default",
  "destructive": "input-module-scss-module__XgxsSW__destructive",
  "disabled": "input-module-scss-module__XgxsSW__disabled",
  "input": "input-module-scss-module__XgxsSW__input",
  "left_slot": "input-module-scss-module__XgxsSW__left_slot",
  "right_slot": "input-module-scss-module__XgxsSW__right_slot",
  "root": "input-module-scss-module__XgxsSW__root",
  "success": "input-module-scss-module__XgxsSW__success",
  "warning": "input-module-scss-module__XgxsSW__warning",
  "wrapper": "input-module-scss-module__XgxsSW__wrapper",
});
